<template>
  <svg
    class="unidentified-object-safe-icon"
    width="28"
    height="28"
    viewBox="0 0 28 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle
      class="auto-cognition-frame"
      cx="14"
      cy="14"
      r="11.5"
      stroke="#18B75C"
      stroke-opacity="0.6"
    />
    <circle cx="14" cy="14" r="4" fill="#18B75C" />
  </svg>
</template>

<script>
export default {
  name: "UnidentifiedObjectSafeIcon",
};
</script>
